<div :class="[showGif ? 'background-animasi' : 'background-animasi-end']" class="overflow-y-auto">
    <div class="grid p-5 justify-content-center align-content-start ">

        <div class="col-12 lg:col-5 xl:col-5">


            <header-card :is_loading="is_loading" title="Profil Kami" icon="🏥"
                subtitle="INSTALASI GIZI RSUD dr. Soeroto Ngawi" :clickable="true" route="/home">
            </header-card>
        </div>



        <div class="col-12  ">
            <div v-for="(item, index) in data" :key="index" class="img-profil">

                <!--File---------------------------------------------------->
                <div v-if="item.file != ''">

                    <div v-if="categorizeFiles(item) == 'image'" :key="item.file">
                        <p-image :src="item.url_cors" alt="Image" width="100%" preview />
                    </div>

                    <div v-else-if="categorizeFiles(item) == 'pdf'" :key="item.file">
                        <p-pdf v-if="item.url_cors" :src="item.url_cors" />
                    </div>
                </div>
                <!--File---------------------------------------------------->

                <!--Video--------------------------------------------------->
                <p-yt v-else :url="item.url" />
                <!--Video--------------------------------------------------->
            </div>

        </div>

    </div>
</div>